import api from './index'

const axios = require('axios')

export default {
    getAll: () => {
        const path = '/users/all'

        return api.handling(axios.get(path))
    },

    getInfo: (id) => {
        const path = `/users/${id}/info`

        return api.handling(axios.get(path))
    },

    updateInfo: (id, data) => {
        const path = `/users/${id}/info`

        return api.handling(axios.put(path, data))
    },

    getMachines: (id) => {
        const path = `/users/${id}/machines`

        return api.handling(axios.get(path))
    },

    updateMachines: (id, data) => {
        const path = `/users/${id}/machines`

        return api.handling(axios.put(path, data))
    },

    create: (data) => {
        const path = '/users/create'

        return api.handling(axios.post(path, data))
    }
}
